import React, { useState, ReactNode } from 'react';
import { UserContext, UserContextProps } from './UserContext'; 
interface UserProviderProps {
    children: ReactNode;
  }

export const UserProvider:React.FC<UserProviderProps> = ({ children }) => {
  const [userDataState, setUserDataState] = useState<UserContextProps>({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    address: {
      streetAddress: '',
      country: '',
      zipCode: '',
      city: '',
      state: '',
    },
    setUserData: (data: Partial<UserContextProps>) => {
      setUserDataState((prevData) => ({ ...prevData, ...data }));
    },
  });

  return (
    <UserContext.Provider value={{ ...userDataState, setUserData: userDataState.setUserData }}>
      {children}
    </UserContext.Provider>
  );
};
